import * as Fetch from '../data/Fetch';

const setAllSponsorsType = 'SET_ALL_SPONSORS';
const setSponsorType = 'SET_SPONSOR';
const setSponsorsFetchingType = 'SET_SPONSORS_FETCHING';

const initialState = {
    all: null,
    fetching: false,
    sponsor: null
};

export const emptySponsor = {
    code: "",
    name: "",
    studies: null
};

export const actionCreators = {
    create: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sponsorsState = getState().sponsors;
        if (badState(accountsState, sponsorsState, true, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Sponsors/AddNew`);
        const sponsor = sponsorsState.sponsor;
        const body = JSON.stringify({
            code: sponsor.code,
            name: sponsor.name,
            studies: sponsor.studies
        });
        await Fetch.postRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    getAll: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sponsorsState = getState().sponsors;
        if (badState(accountsState, sponsorsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Sponsors/GetAll");
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllSponsorsType);
    },

    getAllByUser: (userId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sponsorsState = getState().sponsors;
        if (badState(accountsState, sponsorsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Sponsors/GetAllByUser/${userId}`);
        const data = await Fetch.getRequest(url, null);
        setResponse(data, dispatch, setAllSponsorsType);
    },

    get: (sponsorId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sponsorsState = getState().sponsors;
        if (badState(accountsState, sponsorsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Sponsors/GetById?id=${sponsorId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setSponsorType);
    },

    set: (data) => async (dispatch) => {
        dispatch({ type: setSponsorType, data });
    },

    update: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sponsorsState = getState().sponsors;
        if (badState(accountsState, sponsorsState, true, dispatch)) {
            return;
        }

        const sponsor = sponsorsState.sponsor;
        const url = await Fetch.getUrl(`Sponsors/Update?id=${sponsor.id}`);
        const body = JSON.stringify({
            code: sponsor.code,
            name: sponsor.name,
            studies: sponsor.studies
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    }
};

function badState(accountsState, sponsorsState, checkSponsor, dispatch) {
    if (accountsState == null ||
        sponsorsState == null ||
        sponsorsState.fetching) {
        return true;
    }
    if (checkSponsor &&
        sponsorsState.sponsor == null) {
        return true;
    }

    setFetching(true, dispatch);
    return false;
}

function setFetching(data, dispatch) {
    dispatch({ type: setSponsorsFetchingType, data });
}

function setResponse(data, dispatch, type) {
    Fetch.setResponse(data, dispatch, type, setSponsorsFetchingType);
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setAllSponsorsType) {
        return {
            ...state,
            all: action.data
        };
    }

    if (action.type === setSponsorType) {
        return {
            ...state,
            sponsor: action.data
        };
    }

    if (action.type === setSponsorsFetchingType) {
        return {
            ...state,
            fetching: action.data
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/Sponsors.js